var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "basic_text cmp-inner",
        _vm.module.isEditing ? "basic_text_editing" : "",
        _vm.module.textType == "positionInfo" ? "grayBj" : "",
      ],
      style: _vm.style,
      on: {
        "!dblclick": function ($event) {
          return _vm.on_double_click.apply(null, arguments)
        },
        click: _vm.on_click,
      },
    },
    [
      _c("div", {
        staticClass: "my-text-wrapper my-contenteditable",
        domProps: { innerHTML: _vm._s(_vm.module.text) },
        on: {
          focus: _vm.onFocusContentEditable,
          blur: _vm.onBlurContentEditable,
          mouseup: _vm.onMouseUpContentEditable,
          keydown: _vm.onKeyDownContentEditable,
          paste: _vm.onPaste,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }